<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<rect class="bright" x="6" y="3" width="5" height="1" />
	<polygon class="bright" points="11,9 5.72,9 2.72,4 1,4 1,3 3.28,3 6.28,8 11,8" />
</svg>
</template>